import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        '@$': 'title',
      },
      type: 'table',
      content: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'piSwitch',
                },
                true,
              ],
            },
            {
              '{}': {
                count: {
                  '`': {
                    selection: {
                      '#': {
                        '@': 'employees',
                      },
                    },
                    subqueries: {
                      employees: {
                        filter: {
                          or: [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                            {
                              in: [
                                {
                                  '[]': [
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                  ],
                                },
                                {
                                  '@': 'projectOrgs',
                                },
                              ],
                            },
                          ],
                        },
                        target: 'ent:!personnel:!employee',
                        selection: {
                          '@.': '!id',
                        },
                        subqueries: {
                          projects: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!proj',
                            },
                            using: 'projectPiAssignments',
                            filter: {
                              or: [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  '=': [
                                    {
                                      '@.': [
                                        '!org',
                                        {
                                          ref: {
                                            entity: {
                                              '``': {
                                                '@$': 'orgEntityId',
                                              },
                                            },
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                            target: 'ent:!projects:!proj',
                          },
                          projectOrgs: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!proj',
                            },
                            using: 'projectPiAssignments',
                            filter: {
                              '!=': [
                                {
                                  '@': 'organizations',
                                },
                                {
                                  '[]': [],
                                },
                              ],
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '@': 'organizations',
                            },
                            subqueries: {
                              organizations: {
                                ref: {
                                  attr: 'attr:ent#!projects#!proj:!org',
                                },
                                target: 'dim::!org',
                                selection: {
                                  '@.': '!id',
                                },
                              },
                            },
                          },
                          projectPiAssignments: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!pi',
                            },
                            target: 'ent:!proj_pis:!entry',
                          },
                        },
                      },
                    },
                  },
                },
                query: {
                  '`': {
                    filter: {
                      or: [
                        {
                          '=': [
                            {
                              '``': {
                                '@$': 'orgRecordId',
                              },
                            },
                            null,
                          ],
                        },
                        {
                          in: [
                            {
                              '[]': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                              ],
                            },
                            {
                              '@': 'projectOrgs',
                            },
                          ],
                        },
                      ],
                    },
                    target: 'ent:!personnel:!employee',
                    selection: {
                      '{}': {
                        fields: {
                          '{}': {
                            '2021': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2021',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2022': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2022',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2023': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2023',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2024': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2024',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2025': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2025',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            code: {
                              '{}': {
                                value: {
                                  '@.': '!code',
                                },
                              },
                            },
                            name: {
                              '{}': {
                                value: {
                                  '@.': '!name',
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    subqueries: {
                      projects: {
                        ref: {
                          attr: 'attr:ent#!proj_pis#!entry:!proj',
                        },
                        using: 'projectPiAssignments',
                        filter: {
                          or: [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@.': [
                                    '!org',
                                    {
                                      ref: {
                                        entity: {
                                          '``': {
                                            '@$': 'orgEntityId',
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        target: 'ent:!projects:!proj',
                      },
                      projectOrgs: {
                        ref: {
                          attr: 'attr:ent#!proj_pis#!entry:!proj',
                        },
                        using: 'projectPiAssignments',
                        filter: {
                          '!=': [
                            {
                              '@': 'organizations',
                            },
                            {
                              '[]': [],
                            },
                          ],
                        },
                        target: 'ent:!projects:!proj',
                        selection: {
                          '@': 'organizations',
                        },
                        subqueries: {
                          organizations: {
                            ref: {
                              attr: 'attr:ent#!projects#!proj:!org',
                            },
                            target: 'dim::!org',
                            selection: {
                              '@.': '!id',
                            },
                          },
                        },
                      },
                      expenses2021: {
                        using: 'projects',
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2021',
                            },
                            start: {
                              $date: '1/1/2021',
                            },
                          },
                        },
                        target: 'ent:!projects:!proj',
                        selection: {
                          '+': {
                            '->': [
                              {
                                '@': 'projectGlExpenses',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '``': {
                                                '@$': 'financialVolume',
                                              },
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        'mtdcAmount',
                                      ],
                                      'tdcAmount',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                        subqueries: {
                          projectGlExpenses: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '{}': {
                                tdcAmount: {
                                  if: [
                                    [
                                      {
                                        not: {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                idcrAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                mtdcAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                              },
                            },
                            subqueries: {
                              costType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!cost_type',
                                },
                              },
                            },
                          },
                        },
                      },
                      expenses2022: {
                        using: 'projects',
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2022',
                            },
                            start: {
                              $date: '1/1/2022',
                            },
                          },
                        },
                        target: 'ent:!projects:!proj',
                        selection: {
                          '+': {
                            '->': [
                              {
                                '@': 'projectGlExpenses',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '``': {
                                                '@$': 'financialVolume',
                                              },
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        'mtdcAmount',
                                      ],
                                      'tdcAmount',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                        subqueries: {
                          projectGlExpenses: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '{}': {
                                tdcAmount: {
                                  if: [
                                    [
                                      {
                                        not: {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                idcrAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                mtdcAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                              },
                            },
                            subqueries: {
                              costType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!cost_type',
                                },
                              },
                            },
                          },
                        },
                      },
                      expenses2023: {
                        using: 'projects',
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2023',
                            },
                            start: {
                              $date: '1/1/2023',
                            },
                          },
                        },
                        target: 'ent:!projects:!proj',
                        selection: {
                          '+': {
                            '->': [
                              {
                                '@': 'projectGlExpenses',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '``': {
                                                '@$': 'financialVolume',
                                              },
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        'mtdcAmount',
                                      ],
                                      'tdcAmount',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                        subqueries: {
                          projectGlExpenses: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '{}': {
                                tdcAmount: {
                                  if: [
                                    [
                                      {
                                        not: {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                idcrAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                mtdcAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                              },
                            },
                            subqueries: {
                              costType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!cost_type',
                                },
                              },
                            },
                          },
                        },
                      },
                      expenses2024: {
                        using: 'projects',
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2024',
                            },
                            start: {
                              $date: '1/1/2024',
                            },
                          },
                        },
                        target: 'ent:!projects:!proj',
                        selection: {
                          '+': {
                            '->': [
                              {
                                '@': 'projectGlExpenses',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '``': {
                                                '@$': 'financialVolume',
                                              },
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        'mtdcAmount',
                                      ],
                                      'tdcAmount',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                        subqueries: {
                          projectGlExpenses: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '{}': {
                                tdcAmount: {
                                  if: [
                                    [
                                      {
                                        not: {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                idcrAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                mtdcAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                              },
                            },
                            subqueries: {
                              costType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!cost_type',
                                },
                              },
                            },
                          },
                        },
                      },
                      expenses2025: {
                        using: 'projects',
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2025',
                            },
                            start: {
                              $date: '1/1/2025',
                            },
                          },
                        },
                        target: 'ent:!projects:!proj',
                        selection: {
                          '+': {
                            '->': [
                              {
                                '@': 'projectGlExpenses',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '``': {
                                                '@$': 'financialVolume',
                                              },
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        'mtdcAmount',
                                      ],
                                      'tdcAmount',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                        subqueries: {
                          projectGlExpenses: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '{}': {
                                tdcAmount: {
                                  if: [
                                    [
                                      {
                                        not: {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                idcrAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                                mtdcAmount: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@.': '!amount',
                                      },
                                    ],
                                    0,
                                  ],
                                },
                              },
                            },
                            subqueries: {
                              costType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!cost_type',
                                },
                              },
                            },
                          },
                        },
                      },
                      projectPiAssignments: {
                        ref: {
                          attr: 'attr:ent#!proj_pis#!entry:!pi',
                        },
                        target: 'ent:!proj_pis:!entry',
                      },
                    },
                  },
                },
                columns: {
                  '[]': [
                    {
                      '{}': {
                        id: 'code',
                        direct: {
                          '{}': {
                            name: 'Code',
                            type: 'TEXT',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: 'name',
                        direct: {
                          '{}': {
                            name: 'Name',
                            type: 'TEXT',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2021',
                        direct: {
                          '{}': {
                            name: '2021',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2022',
                        direct: {
                          '{}': {
                            name: '2022',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2023',
                        direct: {
                          '{}': {
                            name: '2023',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2024',
                        direct: {
                          '{}': {
                            name: '2024',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2025',
                        direct: {
                          '{}': {
                            name: '2025',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                  ],
                },
                totalRow: {
                  '`': {
                    selection: {
                      '{}': {
                        fields: {
                          '{}': {
                            '2021': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2021',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            '2022': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2022',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            '2023': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2023',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            '2024': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2024',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            '2025': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2025',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            code: {
                              '{}': {
                                value: 'Total',
                              },
                            },
                            name: {
                              '{}': {
                                value: 'Total',
                              },
                            },
                          },
                        },
                      },
                    },
                    subqueries: {
                      records: {
                        filter: {
                          or: [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                            {
                              in: [
                                {
                                  '[]': [
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                  ],
                                },
                                {
                                  '@': 'projectOrgs',
                                },
                              ],
                            },
                          ],
                        },
                        target: 'ent:!personnel:!employee',
                        selection: {
                          '{}': {
                            '2021': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2021',
                                  },
                                },
                                0,
                              ],
                            },
                            '2022': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2022',
                                  },
                                },
                                0,
                              ],
                            },
                            '2023': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2023',
                                  },
                                },
                                0,
                              ],
                            },
                            '2024': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2024',
                                  },
                                },
                                0,
                              ],
                            },
                            '2025': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2025',
                                  },
                                },
                                0,
                              ],
                            },
                          },
                        },
                        subqueries: {
                          projects: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!proj',
                            },
                            using: 'projectPiAssignments',
                            filter: {
                              or: [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  '=': [
                                    {
                                      '@.': [
                                        '!org',
                                        {
                                          ref: {
                                            entity: {
                                              '``': {
                                                '@$': 'orgEntityId',
                                              },
                                            },
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                            target: 'ent:!projects:!proj',
                          },
                          projectOrgs: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!proj',
                            },
                            using: 'projectPiAssignments',
                            filter: {
                              '!=': [
                                {
                                  '@': 'organizations',
                                },
                                {
                                  '[]': [],
                                },
                              ],
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '@': 'organizations',
                            },
                            subqueries: {
                              organizations: {
                                ref: {
                                  attr: 'attr:ent#!projects#!proj:!org',
                                },
                                target: 'dim::!org',
                                selection: {
                                  '@.': '!id',
                                },
                              },
                            },
                          },
                          expenses2021: {
                            using: 'projects',
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2021',
                                },
                                start: {
                                  $date: '1/1/2021',
                                },
                              },
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '+': {
                                '->': [
                                  {
                                    '@': 'projectGlExpenses',
                                  },
                                  {
                                    '@>': [
                                      {
                                        '@$': '$value',
                                      },
                                      {
                                        if: [
                                          [
                                            {
                                              '=': [
                                                {
                                                  '``': {
                                                    '@$': 'financialVolume',
                                                  },
                                                },
                                                'MTDC',
                                              ],
                                            },
                                            'mtdcAmount',
                                          ],
                                          'tdcAmount',
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                            subqueries: {
                              projectGlExpenses: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!gl_exp:!entry',
                                selection: {
                                  '{}': {
                                    tdcAmount: {
                                      if: [
                                        [
                                          {
                                            not: {
                                              '=': [
                                                {
                                                  '@': 'costType',
                                                },
                                                'IDC',
                                              ],
                                            },
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    idcrAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    mtdcAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                  },
                                },
                                subqueries: {
                                  costType: {
                                    ref: {
                                      attr: 'attr:ent#!gl_exp#!entry:!acct',
                                    },
                                    target: 'ent:!gl_accts:!acct',
                                    selection: {
                                      '@.': '!cost_type',
                                    },
                                  },
                                },
                              },
                            },
                          },
                          expenses2022: {
                            using: 'projects',
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2022',
                                },
                                start: {
                                  $date: '1/1/2022',
                                },
                              },
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '+': {
                                '->': [
                                  {
                                    '@': 'projectGlExpenses',
                                  },
                                  {
                                    '@>': [
                                      {
                                        '@$': '$value',
                                      },
                                      {
                                        if: [
                                          [
                                            {
                                              '=': [
                                                {
                                                  '``': {
                                                    '@$': 'financialVolume',
                                                  },
                                                },
                                                'MTDC',
                                              ],
                                            },
                                            'mtdcAmount',
                                          ],
                                          'tdcAmount',
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                            subqueries: {
                              projectGlExpenses: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!gl_exp:!entry',
                                selection: {
                                  '{}': {
                                    tdcAmount: {
                                      if: [
                                        [
                                          {
                                            not: {
                                              '=': [
                                                {
                                                  '@': 'costType',
                                                },
                                                'IDC',
                                              ],
                                            },
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    idcrAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    mtdcAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                  },
                                },
                                subqueries: {
                                  costType: {
                                    ref: {
                                      attr: 'attr:ent#!gl_exp#!entry:!acct',
                                    },
                                    target: 'ent:!gl_accts:!acct',
                                    selection: {
                                      '@.': '!cost_type',
                                    },
                                  },
                                },
                              },
                            },
                          },
                          expenses2023: {
                            using: 'projects',
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2023',
                                },
                                start: {
                                  $date: '1/1/2023',
                                },
                              },
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '+': {
                                '->': [
                                  {
                                    '@': 'projectGlExpenses',
                                  },
                                  {
                                    '@>': [
                                      {
                                        '@$': '$value',
                                      },
                                      {
                                        if: [
                                          [
                                            {
                                              '=': [
                                                {
                                                  '``': {
                                                    '@$': 'financialVolume',
                                                  },
                                                },
                                                'MTDC',
                                              ],
                                            },
                                            'mtdcAmount',
                                          ],
                                          'tdcAmount',
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                            subqueries: {
                              projectGlExpenses: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!gl_exp:!entry',
                                selection: {
                                  '{}': {
                                    tdcAmount: {
                                      if: [
                                        [
                                          {
                                            not: {
                                              '=': [
                                                {
                                                  '@': 'costType',
                                                },
                                                'IDC',
                                              ],
                                            },
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    idcrAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    mtdcAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                  },
                                },
                                subqueries: {
                                  costType: {
                                    ref: {
                                      attr: 'attr:ent#!gl_exp#!entry:!acct',
                                    },
                                    target: 'ent:!gl_accts:!acct',
                                    selection: {
                                      '@.': '!cost_type',
                                    },
                                  },
                                },
                              },
                            },
                          },
                          expenses2024: {
                            using: 'projects',
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2024',
                                },
                                start: {
                                  $date: '1/1/2024',
                                },
                              },
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '+': {
                                '->': [
                                  {
                                    '@': 'projectGlExpenses',
                                  },
                                  {
                                    '@>': [
                                      {
                                        '@$': '$value',
                                      },
                                      {
                                        if: [
                                          [
                                            {
                                              '=': [
                                                {
                                                  '``': {
                                                    '@$': 'financialVolume',
                                                  },
                                                },
                                                'MTDC',
                                              ],
                                            },
                                            'mtdcAmount',
                                          ],
                                          'tdcAmount',
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                            subqueries: {
                              projectGlExpenses: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!gl_exp:!entry',
                                selection: {
                                  '{}': {
                                    tdcAmount: {
                                      if: [
                                        [
                                          {
                                            not: {
                                              '=': [
                                                {
                                                  '@': 'costType',
                                                },
                                                'IDC',
                                              ],
                                            },
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    idcrAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    mtdcAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                  },
                                },
                                subqueries: {
                                  costType: {
                                    ref: {
                                      attr: 'attr:ent#!gl_exp#!entry:!acct',
                                    },
                                    target: 'ent:!gl_accts:!acct',
                                    selection: {
                                      '@.': '!cost_type',
                                    },
                                  },
                                },
                              },
                            },
                          },
                          expenses2025: {
                            using: 'projects',
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2025',
                                },
                                start: {
                                  $date: '1/1/2025',
                                },
                              },
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '+': {
                                '->': [
                                  {
                                    '@': 'projectGlExpenses',
                                  },
                                  {
                                    '@>': [
                                      {
                                        '@$': '$value',
                                      },
                                      {
                                        if: [
                                          [
                                            {
                                              '=': [
                                                {
                                                  '``': {
                                                    '@$': 'financialVolume',
                                                  },
                                                },
                                                'MTDC',
                                              ],
                                            },
                                            'mtdcAmount',
                                          ],
                                          'tdcAmount',
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                            subqueries: {
                              projectGlExpenses: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!gl_exp:!entry',
                                selection: {
                                  '{}': {
                                    tdcAmount: {
                                      if: [
                                        [
                                          {
                                            not: {
                                              '=': [
                                                {
                                                  '@': 'costType',
                                                },
                                                'IDC',
                                              ],
                                            },
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    idcrAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                    mtdcAmount: {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          {
                                            '@.': '!amount',
                                          },
                                        ],
                                        0,
                                      ],
                                    },
                                  },
                                },
                                subqueries: {
                                  costType: {
                                    ref: {
                                      attr: 'attr:ent#!gl_exp#!entry:!acct',
                                    },
                                    target: 'ent:!gl_accts:!acct',
                                    selection: {
                                      '@.': '!cost_type',
                                    },
                                  },
                                },
                              },
                            },
                          },
                          projectPiAssignments: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!pi',
                            },
                            target: 'ent:!proj_pis:!entry',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          ],
          {
            '{}': {
              count: {
                '`': {
                  selection: {
                    '#': {
                      '@': 'orgs',
                    },
                  },
                  subqueries: {
                    orgs: {
                      filter: {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      target: 'dim::!org',
                      selection: {
                        '@.': '!id',
                      },
                      subqueries: {
                        expenses2022: {
                          using: 'projectAssignments',
                          target: 'ent:!projects:!proj',
                          selection: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '``': {
                                                  '@$': 'financialVolume',
                                                },
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          'mtdcAmount',
                                        ],
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                          subqueries: {
                            projectGlExpenses: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!gl_exp:!entry',
                              selection: {
                                '{}': {
                                  tdcAmount: {
                                    if: [
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  idcrAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  mtdcAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                },
                              },
                              subqueries: {
                                costType: {
                                  ref: {
                                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                                  },
                                  target: 'ent:!gl_accts:!acct',
                                  selection: {
                                    '@.': '!cost_type',
                                  },
                                },
                              },
                            },
                          },
                        },
                        projectAssignments: {
                          ref: {
                            attr: 'attr:ent#!projects#!entry:!org',
                            inherit: '-',
                          },
                          target: 'ent:!projects:!proj',
                        },
                      },
                    },
                  },
                },
              },
              query: {
                '`': {
                  filter: {
                    '=': [
                      {
                        '@^': 'parent',
                      },
                      {
                        '``': {
                          '@$': 'orgRecordId',
                        },
                      },
                    ],
                  },
                  target: 'dim::!org',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          '2021': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2021',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          '2022': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2022',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          '2023': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2023',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          '2024': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2024',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          '2025': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2025',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: {
                                '@.': '!code',
                              },
                            },
                          },
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                        },
                      },
                      onClick: {
                        '{}': {
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          title: {
                                            if: [
                                              [
                                                {
                                                  and: [
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '@': 'hasChild',
                                                          },
                                                          null,
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '@': 'hasChild',
                                                          },
                                                          {
                                                            '[]': [],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                                'Organizations',
                                              ],
                                              'PIs',
                                            ],
                                          },
                                          piSwitch: {
                                            if: [
                                              [
                                                {
                                                  and: [
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '@': 'hasChild',
                                                          },
                                                          null,
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '@': 'hasChild',
                                                          },
                                                          {
                                                            '[]': [],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                                false,
                                              ],
                                              true,
                                            ],
                                          },
                                          orgEntityId: {
                                            '@_': 'id',
                                          },
                                          orgRecordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'trends',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    hasChild: {
                      target: 'child',
                      selection: true,
                    },
                    expenses2021: {
                      using: 'projectAssignments',
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2021',
                          },
                          start: {
                            $date: '1/1/2021',
                          },
                        },
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      'mtdcAmount',
                                    ],
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              tdcAmount: {
                                if: [
                                  [
                                    {
                                      not: {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              idcrAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'IDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            costType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!cost_type',
                              },
                            },
                          },
                        },
                      },
                    },
                    expenses2022: {
                      using: 'projectAssignments',
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2022',
                          },
                          start: {
                            $date: '1/1/2022',
                          },
                        },
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      'mtdcAmount',
                                    ],
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              tdcAmount: {
                                if: [
                                  [
                                    {
                                      not: {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              idcrAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'IDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            costType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!cost_type',
                              },
                            },
                          },
                        },
                      },
                    },
                    expenses2023: {
                      using: 'projectAssignments',
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2023',
                          },
                          start: {
                            $date: '1/1/2023',
                          },
                        },
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      'mtdcAmount',
                                    ],
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              tdcAmount: {
                                if: [
                                  [
                                    {
                                      not: {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              idcrAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'IDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            costType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!cost_type',
                              },
                            },
                          },
                        },
                      },
                    },
                    expenses2024: {
                      using: 'projectAssignments',
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2024',
                          },
                          start: {
                            $date: '1/1/2024',
                          },
                        },
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      'mtdcAmount',
                                    ],
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              tdcAmount: {
                                if: [
                                  [
                                    {
                                      not: {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              idcrAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'IDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            costType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!cost_type',
                              },
                            },
                          },
                        },
                      },
                    },
                    expenses2025: {
                      using: 'projectAssignments',
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2025',
                          },
                          start: {
                            $date: '1/1/2025',
                          },
                        },
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      'mtdcAmount',
                                    ],
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              tdcAmount: {
                                if: [
                                  [
                                    {
                                      not: {
                                        '=': [
                                          {
                                            '@': 'costType',
                                          },
                                          'IDC',
                                        ],
                                      },
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              idcrAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'IDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            costType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!cost_type',
                              },
                            },
                          },
                        },
                      },
                    },
                    projectAssignments: {
                      ref: {
                        attr: 'attr:ent#!projects#!entry:!org',
                        inherit: '-',
                      },
                      target: 'ent:!projects:!proj',
                    },
                  },
                },
              },
              columns: {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      direct: {
                        '{}': {
                          name: 'Code',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      direct: {
                        '{}': {
                          name: 'Name',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2021',
                      direct: {
                        '{}': {
                          name: '2021',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2022',
                      direct: {
                        '{}': {
                          name: '2022',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2023',
                      direct: {
                        '{}': {
                          name: '2023',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2024',
                      direct: {
                        '{}': {
                          name: '2024',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2025',
                      direct: {
                        '{}': {
                          name: '2025',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                ],
              },
              totalRow: {
                '`': {
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          '2021': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2021',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          '2022': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2022',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          '2023': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2023',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          '2024': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2024',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          '2025': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2025',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: 'Total',
                            },
                          },
                          name: {
                            '{}': {
                              value: 'Total',
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    records: {
                      filter: {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      target: 'dim::!org',
                      selection: {
                        '{}': {
                          '2021': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2021',
                                },
                              },
                              0,
                            ],
                          },
                          '2022': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2022',
                                },
                              },
                              0,
                            ],
                          },
                          '2023': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2023',
                                },
                              },
                              0,
                            ],
                          },
                          '2024': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2024',
                                },
                              },
                              0,
                            ],
                          },
                          '2025': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2025',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        expenses2021: {
                          using: 'projectAssignments',
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2021',
                              },
                              start: {
                                $date: '1/1/2021',
                              },
                            },
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '``': {
                                                  '@$': 'financialVolume',
                                                },
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          'mtdcAmount',
                                        ],
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                          subqueries: {
                            projectGlExpenses: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!gl_exp:!entry',
                              selection: {
                                '{}': {
                                  tdcAmount: {
                                    if: [
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  idcrAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  mtdcAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                },
                              },
                              subqueries: {
                                costType: {
                                  ref: {
                                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                                  },
                                  target: 'ent:!gl_accts:!acct',
                                  selection: {
                                    '@.': '!cost_type',
                                  },
                                },
                              },
                            },
                          },
                        },
                        expenses2022: {
                          using: 'projectAssignments',
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2022',
                              },
                              start: {
                                $date: '1/1/2022',
                              },
                            },
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '``': {
                                                  '@$': 'financialVolume',
                                                },
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          'mtdcAmount',
                                        ],
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                          subqueries: {
                            projectGlExpenses: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!gl_exp:!entry',
                              selection: {
                                '{}': {
                                  tdcAmount: {
                                    if: [
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  idcrAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  mtdcAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                },
                              },
                              subqueries: {
                                costType: {
                                  ref: {
                                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                                  },
                                  target: 'ent:!gl_accts:!acct',
                                  selection: {
                                    '@.': '!cost_type',
                                  },
                                },
                              },
                            },
                          },
                        },
                        expenses2023: {
                          using: 'projectAssignments',
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2023',
                              },
                              start: {
                                $date: '1/1/2023',
                              },
                            },
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '``': {
                                                  '@$': 'financialVolume',
                                                },
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          'mtdcAmount',
                                        ],
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                          subqueries: {
                            projectGlExpenses: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!gl_exp:!entry',
                              selection: {
                                '{}': {
                                  tdcAmount: {
                                    if: [
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  idcrAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  mtdcAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                },
                              },
                              subqueries: {
                                costType: {
                                  ref: {
                                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                                  },
                                  target: 'ent:!gl_accts:!acct',
                                  selection: {
                                    '@.': '!cost_type',
                                  },
                                },
                              },
                            },
                          },
                        },
                        expenses2024: {
                          using: 'projectAssignments',
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2024',
                              },
                              start: {
                                $date: '1/1/2024',
                              },
                            },
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '``': {
                                                  '@$': 'financialVolume',
                                                },
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          'mtdcAmount',
                                        ],
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                          subqueries: {
                            projectGlExpenses: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!gl_exp:!entry',
                              selection: {
                                '{}': {
                                  tdcAmount: {
                                    if: [
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  idcrAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  mtdcAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                },
                              },
                              subqueries: {
                                costType: {
                                  ref: {
                                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                                  },
                                  target: 'ent:!gl_accts:!acct',
                                  selection: {
                                    '@.': '!cost_type',
                                  },
                                },
                              },
                            },
                          },
                        },
                        expenses2025: {
                          using: 'projectAssignments',
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2025',
                              },
                              start: {
                                $date: '1/1/2025',
                              },
                            },
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    {
                                      if: [
                                        [
                                          {
                                            '=': [
                                              {
                                                '``': {
                                                  '@$': 'financialVolume',
                                                },
                                              },
                                              'MTDC',
                                            ],
                                          },
                                          'mtdcAmount',
                                        ],
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                          subqueries: {
                            projectGlExpenses: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!gl_exp:!entry',
                              selection: {
                                '{}': {
                                  tdcAmount: {
                                    if: [
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@': 'costType',
                                              },
                                              'IDC',
                                            ],
                                          },
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  idcrAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'IDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                  mtdcAmount: {
                                    if: [
                                      [
                                        {
                                          '=': [
                                            {
                                              '@': 'costType',
                                            },
                                            'MTDC',
                                          ],
                                        },
                                        {
                                          '@.': '!amount',
                                        },
                                      ],
                                      0,
                                    ],
                                  },
                                },
                              },
                              subqueries: {
                                costType: {
                                  ref: {
                                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                                  },
                                  target: 'ent:!gl_accts:!acct',
                                  selection: {
                                    '@.': '!cost_type',
                                  },
                                },
                              },
                            },
                          },
                        },
                        projectAssignments: {
                          ref: {
                            attr: 'attr:ent#!projects#!entry:!org',
                            inherit: '-',
                          },
                          target: 'ent:!projects:!proj',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    title: 'Organization Groups',
    piSwitch: false,
    financialVolume: 'MTDC',
  },
}
